/* eslint-disable max-len */
export default {
    controls: {
        profile: 'Profile',
        next: 'Next',
        previous: 'Previous',
        goback: 'Back',
        close: 'Close',
    },
    landing: {
        banner: {
            title: 'The best Cartoon Network shows in one place!',
            text:
                'On the Cartoon Network App you can watch your favorite shows such as Ben 10, Adventure Time, he Powerpuff Girls, We Bare Bares, and more.',
            button: 'Find out more',
        },
        shows: {
            title: 'Your favourite shows on the go!',
            text:
                'Watch TV shows on your phone, tablet, laptop, and TV without paying more.',
        },
        benefits: {
            title: {
                part1: 'A lot more Cartoon Network',
                part2: 'for you to enjoy',
            },
            feature1: {
                title: 'Full episodes',
                text:
                    'Watch complete episodes from The Incredible World of Gumball, Ben 10 and more!',
            },
            feature2: {
                title: 'Be up-to-date!',
                text:
                    'Missed an Infinity Train episode? Watch the most recent shows here!',
            },
            feature3: {
                title: 'Exclusive Premieres',
                text: 'New shows? You will be able to watch first here!',
            },
        },
        login: 'LOGIN',
        help: 'I need help',
        skip: 'Skip for now',
        available: 'Also available for download on',
    },
    walkthrough: {
        page1: {
            title: 'I want to access!',
            text:
                'Access the Cartoon Network App through our partners or cable provider',
        },
        page2: {
            title: 'Do I have to pay for it?',
            text:
                'That depends on the plan you have with the provider or partner. Check out our Help Center!',
        },
        page3: {
            title: 'Cartoon Network Originals and more!',
            text:
                'Your favorite shows in one place! Full seasons and new episodes to watch whenever you want!',
        },
    },
    login: {
        title: "Please ask for help with registration if you aren't an adult",
        continue: 'CONTINUE',
        help_title: 'Please ask for help',
        help_subtitle: 'Make sure to ask Mum or Dad to help you with this.',
    },
    AAA: {
        title: 'Firstly, do you have a CN subscription?',
        subtitle: 'Select your operator or partner below',
        failure:
            'You do not have access to this content. If in doubt, contact your operator.',
    },
    favorites: {
        title: 'Favorites',
        shows: 'Favorite Shows',
        episodes: 'Favorite Episodes',
        noContent: 'NO SHOWS OR EPISODES ADDED TO YOUR FAVORITES',
        noShowTitle: 'NO SHOWS ADDED TO YOUR FAVORITES',
        noEpisodeTitle: 'NO EPISODES ADDED TO YOUR FAVORITES',
        description1:
            'Go ahead and add your favorite shows and episodes. Just tap the ',
        description2: ' and they will appear here',
    },
    footerV2: {
        description:
            'Welcome to the official Cartoon Network site! Here you can find the best cartoons, free games, livestreams with full episodes and much more, everyday. Shows like Ben 10, Teen Titans Go!, Scooby Doo, Tom & Jerry, Craig of the Creek, Looney Tunes, Apple and Onion, Amazing World of Gumball and more! \n\n On Cartoonito, parents and younger kids can check out the best pre-school content. Watch clips and other show in a safe area dedicated to it. Have something to say? Talk to us on hola@cartoonnetwork.com',
        downloadApp:
            'Download the app now and ensure fun for the whole family!',
        privacyPolicy: 'Privacy',
        termsOfUse: 'Terms of Use',
        FAQandHelp: 'FAQ y Ayuda',
        tradeMarks: 'Informações de Marcas Registradas',
        cookiesPolicy: 'Política sobre Cookies',
        advertise: 'Anuncie',
        schedule: 'Horário',
        preferencesPanel: 'Painel de Preferências',
        disclaimer:
            'Use of this site signifies your agreement to the Terms of Use. TM & © 2022 Cartoon Network. A Warner Bros Discovery Company. All Rights Reserved. Cartoon Network App is part of the Turner Sports and Entertainment Digital Network.',
        cookies: 'Manage Cookies',
    },
    home: {
        title: 'Home',
        watchNext: 'WATCH NEXT',
        recommended: 'RECOMMENDED',
        mostWatched: 'MOST WATCHED',
        comedy: 'COMEDY',
        adventure: 'ADVENTURE',
        newReleases: 'NEW RELEASES',
        metaTitle: 'Cartoon Network App - Watch Cartoons and Exclusive Shows!',
        metaDescription:
            'The Best from Cartoon Network in one place. Watch shows like Ben 10, Adventure Time, Steven Universe, The Powerpuff Girls and much more!',
        games: 'TOP GAMES',
    },
    shows: {
        title: 'Cartoons',
        about: 'ABOUT',
        season: 'SEASON',
        minisodes: 'Minisodes',
        shorts: 'Shorts',
        similar: 'SIMILAR SHOWS',
        favorited: 'Show added to favorites',
        unfavorited: 'Show removed',
    },
    movies: {
        title: 'Movies',
    },
    onnow: {
        title: 'On Now',
        previewTitle: 'Cartoon Network TV',
        previewSubtitle:
            'Watch your favourite live cartoons and TV Shows! Directly on the CN App wherever and whenever, so you’ll never miss latest shows',
        previewCTA: 'Start watching',
        geoblockError:
            'Looks like you are not in the correct country to be able to watch this content with your account',
        seoLiveTitle: 'Watch live on Cartoon Network our digital originals',
        seoLiveDescription:
            'Live streaming of our original content that you can only watch here on Cartoon Network. Watch episodes and shorts from your favorite cartoons like Gumball, Steven Universe and more! You can watch our digital originals wherever you are.',
    },
    onnowV2: {
        tabTitle: 'On Now',
        title: 'Watch live shows',
        subtitle:
            'Enjoy the live Cartoon Network TV channel and exclusive live shows.',
        subtitleNoTV: 'Enjoy live shows exclusive from Cartoon Network.',
        liveTV: 'Live TV',
        livestream: 'Live Stream',
        liveNow: 'Live Now',
        liveTVTitle: 'Cartoon Network TV',
        notificationsDisabledTitle:
            'Turn notifications on to receive news from our shows and livestreams.',
        notificationsAction: 'Send me notifications',
        emptyTitle: 'There is nothing live right now',
        emptySubTitle:
            'Check back later to see if any livestreams are about to start.',
        emptySubtitleNoNotification:
            'Turn on the notifications and be alerted when we have news from shows and livestreams.',
        notificationsEnabledTitle:
            'We’ll notify you on news about shows and livestreams.',
    },
    video: {
        upNext: 'UP NEXT',
        autoplay: 'Autoplay',
        recommended: 'YOU MIGHT LIKE',
        episode: 'Episode',
        concurrencyError:
            'You have too many devices logged in at the same time. Please, log out from other device to continue.',
        favorited: 'Episode added to favorites',
        unfavorited: 'Episode removed',
        titleFormat: 'S{season}:E{episode}',
        findOut: 'Find out more about this show',
        noContent: 'No content available',
    },
    killSwitch: {
        updateRequired: {
            title: 'We need you to update',
            subtitle:
                'Due to a security concern you need to update this app to the newest version',
            cta: 'UPDATE NOW',
        },
        serviceError: {
            title: 'Well, this is unexpected...',
            subtitle:
                "An error has occurred and we are working to fix the problem. We'll be up and running shortly",
        },
        updateOptional: {
            title: 'New Version Available',
            subtitle:
                'There is a newer version available for download! Please update the app by visiting your App Store',
            cta: 'UPDATE NOW',
            skip: 'Not Now',
        },
    },
    error: {
        title: 'OH OH',
        subtitle: 'Something went wrong',
        cta: 'Back to home',
        cnito: {
            title: 'Oops! Something Went Wrong',
            subtitle: 'Please try that again later, we are trying to fix it.',
        },
    },
    logout: {
        message: 'Do you really want to log out?',
        confirm: 'Yes',
        cancel: 'Cancel',
    },
    FAQandHelp: 'FAQ and Help',
    drawer: {
        pushNotifications: 'Notifications',
        logout: 'Logout',
    },
    pushNudge: {
        title: "Don't miss out",
        subtitle1:
            'Enable notifications about shows and other services. click the ',
        subtitle2: ' icon to turn this on and off, if you change your mind.',
        disclaimer: 'Make sure to check with an adult to see if this is okay?',
        cta: 'ENABLE NOTIFICATIONS',
        skip: 'Not Now',
    },
    notifications: {
        title: 'Notifications',
        text:
            'Cartoon Network can notify you about the latest shows and other services on your mobile or tablet devices.',
        disclaimer:
            'Make sure to check with your Mum or Dad to see if this is okay?',
        switchTitle: 'Send me push notifications',
    },
    mobileData: {
        title: 'Mobile Data',
        subtitle:
            'Cartoon Network can play videos through WIFI and mobile data, but playing through data could cost you money.',
        disclaimer:
            'We can turn off playing videos with your data if that helps?',
        switchLabel: 'Enable playing videos with data',
        modalTitle: 'Oh no! You currently dont have your Mobile data enabled',
        modalSubtitle:
            'To play videos using your data, go to settings and enable data playback',
        modalCTA: 'Take me to settings',
        modalSkip: 'I’ll wait until I have WIFI',
    },
    lockedContent: {
        homeText: 'LOGIN TO WATCH FULL EPISODES!',
        showText: 'LOGIN TO WATCH FULL EPISODES!',
        favoriteText: 'LOGIN TO WATCH FULL EPISODES!',
        unlockShow: 'UNLOCK {{show_title}} FULL EPISODES',
        shows: {
            title: 'WATCH MORE',
            subtitle: 'Login to watch full episodes of your favorite shows',
            cta: 'LOGIN NOW',
        },
        playback: {
            title: 'FULL EPISODES',
            subtitle:
                'Login to access and watch full episodes of your favorite shows',
            cta: 'LOGIN NOW',
        },
        interstitial: {
            title: 'UNLOCK MORE CONTENT',
            subtitle:
                'Log in through your cable provider or one of our partners',
            item1: 'More Shows',
            item2: 'Recent episodes',
            item3: 'Movies',
            item4: 'Add Favorites',
            disclaimer: 'Make sure to ask for help from an adult to continue.',
            cta: 'LOG IN',
            skip: 'Keep Exploring',
        },
        drawer: {
            cta: 'Log in',
        },
        bottomSheet: {
            title: 'UNLOCK MORE',
            subtitle: 'With a partner login',
        },
    },
    downloadApp: {
        title: 'Download the app.',
        text1:
            'For a better experience, we recommend downloading the mobile app.',
        text2:
            'Download the app and enjoy the content with your entire family!',
        text3:
            'Please check if you have access with your cable or mobile provider.',
    },
    unsupported:
        "We still don't support this browser. Pleas access using Google Chrome or Firefox.",
    cast: {
        connectTo: 'Connect to',
        connectingTo: 'Connecting to',
        connectedTo: 'Connected to',
        castingTo: 'Casting to ',
        disconnect: 'Disconnect',
    },
    smartBanner: {
        text: 'For a better experience, use our mobile app',
        cta: 'OPEN APP',
    },
    smartBannerV2: {
        text: 'Enjoy a better experience',
        cta: 'Download the app',
    },
    pickAndPlace: {
        comingSoon: 'COMING SOON',
        live: 'LIVE NOW',
    },
    playerui: {
        replay: {
            title: 'PLAY VIDEO AGAIN',
            nextTimer: 'The next video starts in ',
        },
        settings: {
            title: 'Settings',
            qualityTitle: 'Video Quality',
            qualities: {
                low: 'Low',
                med: 'Med',
                high: 'High',
            },
            languageTitle: 'Language',
            languages: {
                por: 'Portuguese',
                spa: 'Spanish',
                eng: 'English',
            },
        },
    },
    games: {
        title: 'Games',
        featured: 'Featured',
        allGames: 'All games',
        recents: 'Recently played',
        playCTA: 'Play',
        exitModal: {
            title: 'Exit the game?',
            subtitle:
                'If you exit the game now you could lose your score and progress',
            keepPlaying: 'Keep playing',
            exitGame: 'Exit game',
        },
        ad: {
            disclaimer: 'Your game will load after this advert...',
        },
        metaTitle: 'Play with your favorite Cartoon Network characters!',
        metaDescription:
            "Cartoon Network's original games just for you and right here! Call and be called for challenges, go into adventures and play all the best online games with characters you know and love, like Teen Titans, Regular Show and more!",
    },
    ads: {
        unmute: 'Play sound',
        mute: 'Mute sound',
    },
    player: {
        offline: {
            title: 'Oops!',
            message: 'Please check your internet connection and try again.',
            cta: 'Try again',
        },
    },
    cartoonito: {
        landing: {
            title: 'Cartoonito has arrived!',
            message:
                'Cartoon Network introduces Cartoonito, the new preschool brand coming to Latin America, with new exclusive shows, global franchises, local productions and the best content for the youngest children in the family.\nCartoonito is a place to burst out laughing , expand your boundaries and have fun with captivating characters and stories.',
            comingSoon: 'COMING SOON!',
            cta: 'SCHEDULE',
        },
        programming: {
            title: `SCHEDULE`,
            yesterday: 'Yesterday',
            today: 'Today',
            tomorrow: 'Tomorrow',
            yearOfProduction: 'Year of production',
            genres: 'Genres',
            director: 'Director',
            cast: 'Cast',
        },
        cartoons: {
            title: 'Cartoons',
            metaTitle: 'Dibujos y series de Cartoonito',
            metaDescription:
                '¡Tus dibujos animados favoritos como Pocoyo, Thomas and Friends! Nuevos lanzamientos y cortos de Cartoonito!',
        },
        games: {
            title: 'Games',
            metaTitle:
                '¡Juegos para niños con tus personajes favoritos de Cartoonito!',
            metaDescription:
                'Una área de juegos online segura y educativa para los más pequeños. Los mejores juegos como lo juego de memoria con Cartoonito',
        },
        cta: {
            title: 'A new experience is coming',
            button: 'Discover',
        },
        live: {
            title: 'Live',
        },
        videos: {
            title: 'Vídeos',
            metaTitle:
                'Cartoonito! Dibujos y actividades para niños pequeños por Cartoon Network.',
            metaDescription:
                '¡Tus personajes favoritos están aquí! ¡Juega con la Lucas the Spider, Wee Boom y Odo. Consulta la programación y divirtase! ¡Vamos!',
        },
    },
    liveCarousel: {
        title: 'Now Playing',
        live: 'Live',
    },
    onboarding: {
        title: 'CHOOSE AVATAR',
        done: 'DONE',
        skip: 'SKIP',
    },
    parentalPage: {
        title: 'Parents',
        back: 'Back to',
        metaTitle: 'Cartoonito para padres! ¡Actividades familiares!',
        metaDescription:
            'Encuentra aquí las mejores actividades preescolares de los personajes favoritos de los más pequeños, para printar, colorir y jugar',
        welcome: {
            title: 'Welcome',
            subtitle:
                'There’s a new place for preschoolers. And everyone’s invited! We’ll laugh, play, sing, and have a whole lot of fun together on Cartoonito. Our Human-Centric Learning philosophy emphasizes curiosity, caring, creativity, and courage in all of our shows.',
        },
        overview: {
            title: 'Overview',
            learningActivities: 'Learning Activities',
            learningActivitiesDescription:
                'Printable activities for your kids to learn, plan and grow. ',
            learningActivitiesCTA: 'See all activities',
            privacyPolicy: 'Privacy Policy',
        },
        activities: {
            title: 'Activities',
            openCTA: 'Download',
            moreLine1: 'More',
            moreLine2: 'comming',
            moreLine3: 'soon',
        },
        waysToWatch: {
            title: 'Ways to watch',
            subtitles: 'More ways to watch and play with Cartoonito',
            hboSubtitle: 'Watch on HBOMax',
            watchOnTV: 'Watch on TV',
            tvSubtitle: 'View our TV schedule',
            cnitoSubtitle: 'Download the app on',
            disclaimer:
                'Some shows only on Cartoonito or only on HBOMax. Check for availability.',
        },
        settings: {
            title: 'Settings',
            subtitle: 'Control what your kids are seeing and using',
            notifications: {
                title: 'Notifications',
                subtitle:
                    'Cartoon Network can notify your child about the latest shows and other services on your mobile or tablet devices.',
                text: 'Allow my child to recieve push notifications',
            },
            mobileData: {
                title: 'Mobile Data',
                subtitle:
                    'Cartoon Network can play videos through WIFI and mobile data, but playing through data could cost you money.',
                text: 'Enable playing videos with data',
            },
        },
    },
    comics: {
        title: 'Comics',
        continueReading: 'Continue reading',
        newChapters: 'New chapters',
        allComics: 'All comics',
        allChapters: 'All chapters',
        chapter: 'Chapter',
        about: 'About',
        followTitle: 'Follow this comic to be notified abouT new stories',
        followButton: 'Follow',
        followingTitle: 'YOU WILL BE NOTIFIED WHEN A NEW CHAPTER ARRIVES',
        followingButton: 'Following',
        moreComics: 'More comics',
        moreSoon: 'More\nComing\nSoon',
        tutorial1:
            'Swipe down to go back to main comic page, share this episode with your friends or change episode',
        tutorial2: 'Swipe up to see a button that takes you quickly to the top',
        tutorial3:
            'Use the arrows if you want to go to the next or previous chapter',
        tutorial4:
            'Click here if you need to go back to the start of the story',
        tutorialClose: 'Close',
        tutorialSkip: 'Skip',
        previous: 'Previous',
        next: 'Next',
        share: 'Share',
        gotoChapter: 'Go to chapter {chapter}',
        spoiler: {
            title: 'SPOILER ALERT',
            description: 'The last chapter that you read was chapter {chapter}',
            cta: 'Go to chapter {chapter}',
            continue: 'I want to continue to chapter {chapter}',
        },
        read: 'Read',
        readNow: 'Read now',
        chapterRead0: 'No chapters read',
        chapterRead1: '1 chapter read',
        chapterRead2: '{count} chapters read',
    },
    search: {
        placeholder: 'Search',
        recommended: 'Recommended searches',
        didYouMean: 'Did you mean?',
        noResultAlert: 'Oh no!',
        noResultTitle: 'We can’t find what you’re looking for',
        checkLatest: 'Check out the latest clips!',
        help: 'Search for a\ncartoon or game',
    },
    push: {
        idleTitle:
            'Follow our website to\nbe notified about new clips, games and comics',
        idleSubtitle:
            'Make sure to check with your mum or Dad to see if this is okay?',
        idleCTA: 'Follow Cartoon Network',
        followingTitle:
            'You will be notified about new clips, games and comics when we have them',
        followingSubtitle:
            'To turn notifications off go to your browser notification settings and turn them off',
        followingCTA: 'Following Cartoon Network',
    },
    dkids: {
        playArea: 'Play Area',
        homeRow: 'Educational',
        trending: 'Trending Games',
        footerProgramming: 'Programming',
        copyright:
            'Use of this site signifies your agreement to the Terms of Use. TM & © 2022 Discovery Kids. A Warner Bros Discovery Company. All Rights Reserved.',
    },
};
